import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title";
import PerformanceForm from "./auditor-performance-form";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import PerformanceData from "./auditor-performance-data";

const OtherAuditorsPerformance = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "SUPERVISOR_OTHER_AUDITORS_PERFORMANCE",
      "SUPERVISOR_OTHER_AUDITORS_PERFORMANCE"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("OTHER_AUDITORS_PERFORMANCE")}
        subTitle={i18n.get("CONTROL_PANEL")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <PerformanceForm />
      <Et3Margin top={0} bottom={30} left={0} right={0} />
      <PerformanceData />
    </ET3PageDiv>
  );
});

export default OtherAuditorsPerformance;
